
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { utils } from '../../../core';

import getAttributeValueAsText from '../getAttributeValueAsText';

const ObjectEditAttributeText = ({
    allow,
    attribute,
    onChange,
    value
}) => {

    const handleChange = (e) => {
        if (onChange) {
            onChange(attribute.name, e.target.value);
        }
    }

    const readOnly = !allow;

    const processedValue = (readOnly)
        ? getAttributeValueAsText(attribute, value)
        : value;

    return (
        <TextField
            label={attribute.title}
            value={processedValue || ''}
            disabled={readOnly}
            readOnly={readOnly}
            styles={utils.styles.TEXT_BOX_STYLES}
            onChange={handleChange}
        />
    );
}

export default ObjectEditAttributeText;
